
import disneyy from '../images/viewers-disney.png'
import pixar from '../images/viewers-pixar.png'
import marvel from '../images/viewers-marvel.png'
import star from '../images/viewers-starwars.png'
import national from '../images/viewers-national.png'
import classes from './Viewers.module.css'
import vdiney from '../videos/disney.mp4'
import vmarvel from '../videos/marvel.mp4'
import vnational from '../videos/national.mp4'
import vpixar from '../videos/pixar.mp4'
import vstar from '../videos/star.mp4'
import { useState } from 'react'

function Viewers() {

  return (
    <div className={classes.container}>
           <div className={classes.war}>
    <div className={classes.warone}  >
    <video src={vdiney} autoPlay={true}  loop={true} playsInline={true} type="video/mp4"/>
      <img src={disneyy} alt="" />
    </div>
    <div className={classes.warone}>
    <video src={vpixar} autoPlay={true} loop={true} playsInline={true} type="video/mp4"/>
      <img src={pixar} alt="" />
    </div>
    <div className={classes.warone}>
    <video src={vmarvel} autoPlay={true} loop={true} playsInline={true} type="video/mp4"/>
      <img src={marvel} alt="" />
    </div>
    <div className={classes.warone}>
    <video src={vstar} autoPlay={true}  loop={true} playsInline={true} type="video/mp4"/>
      <img src={star} alt="" />
    </div>
    <div className={classes.warone}>
    <video src={vnational} autoPlay={true} loop={true} playsInline={true} type="video/mp4"/>
      <img src={national} alt="" />
    </div>

  </div>
    </div>
 
  )
}

export default Viewers
